module.exports = __webpack_public_path__ + "img/new9.4513c6bb.png";